import React from 'react';
import { toast } from '@/components/ui/Toast';
import cn from '@/utils/cn';

interface AIToastAction {
  href?: string;
  label: string;
  onClick?: () => void;
}

// Shared id for the in-progress/success toast so only one AI status toast shows at a time.
// The failure toast uses its own id (see SectionAIGeneratingPanel) so it never inherits the
// in-progress toast's auto-close timer — it must persist until dismissed (PLAT-17351).
export const STATUS_TOAST_ID = 'ai-leveling-status';

const showLevelingStatusToast = (
  icon: React.ReactNode,
  message: string,
  { action, autoClose = false, toastId = STATUS_TOAST_ID }: {
    action?: AIToastAction;
    autoClose?: number | false;
    toastId?: number | string;
  } = {},
) => {
  const actionElement = action && (action.href ? (
    <a className="tw-font-bold tw-text-tci-purple tw-whitespace-nowrap" href={action.href}>
      {action.label}
    </a>
  ) : (
    <button
      className={cn(
        'tw-font-bold tw-text-tci-purple tw-whitespace-nowrap',
        'tw-bg-transparent tw-border-none tw-cursor-pointer tw-p-0',
      )}
      type="button"
      onClick={action.onClick}
    >
      {action.label}
    </button>
  ));

  toast.show(
    <span className="tw-flex tw-items-center tw-gap-3 tw-text-sm">
      {icon}
      <span className="tw-mr-6">{message}</span>
      {actionElement}
    </span>,
    { autoClose, toastId },
  );
};

export default showLevelingStatusToast;
